export const generateMap = (array) => {
    const result = new Map();
    array.forEach((el) => {
        result.set(el.id, el.fieldsName)
    });
    return result;
};